import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "../../auth/auth-context/auth-context";
import { Routes as RouterRoutes } from "../../helpers/router";
import { OnboardingPersonalDetails } from "../../views/onboarding/personal-details/personal-details";
import { Register } from "../../views/register/register";
import { AppContainer } from "../app-container";
import { LoadingScreen } from "../loading-screen";

export const KioskRoutes = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadingScreen />;
  }

  const fallback = user
    ? RouterRoutes.CreateProfile()
    : RouterRoutes.Register();

  return (
    <Routes>
      <Route
        path={RouterRoutes.Register()}
        element={
          user ? (
            <Navigate to={RouterRoutes.CreateProfile()} replace />
          ) : (
            <AppContainer maxWidth="full">
              <Register />
            </AppContainer>
          )
        }
      />
      <Route
        path={RouterRoutes.CreateProfile()}
        element={
          user ? (
            <AppContainer maxWidth="container.lg">
              <OnboardingPersonalDetails />
            </AppContainer>
          ) : (
            <Navigate to={RouterRoutes.Register()} replace />
          )
        }
      />
      <Route path="*" element={<Navigate to={fallback} replace />} />
    </Routes>
  );
};
